import { IIdomReactionItem } from "src/modules/idom-reaction/models/IdomReactions";

export interface IdomReactionStateInterface {
  reactions: IIdomReactionItem[];
  totalReactions: number;
}

function state(): IdomReactionStateInterface {
  return {
    reactions: [],
    totalReactions: 0,
  };
}

export default state;
